import React from "react";
import HelpHeader from "../HelpHeader";
import { message, Modal } from "antd";
import { bindActionCreators } from "redux";
import { tokenAction } from "../../redux-stuffs/actions/token_action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import api from "../../api/api";
import { defaultFormValues } from "../../api/requiredFunctions";
import { saveCashRequestDto } from "../../redux-stuffs/actions/profile_action";
import { merchantAddressState, merchantNameState, amountState, accessTokenState } from '../../atoms';
import withRecoil from '../../withRecoil';
import queryString from "query-string";
import Header from "../../components/Header";
import { withTranslation } from "react-i18next";
import "./styles/LocationSelector.css";
import { GOOGLE_MAPS_API_KEY } from "../../config/google";

function error(title, content) {
  Modal.error({
    title: title,
    content: content,
  });
}

class LocationSelector extends React.Component {
  constructor(props) {
    super(props);

    const locationState = this.props.location.state || {};

    this.state = {
      businesses: locationState.businesses || [],
      requested_amount: locationState.requested_amount || null,
      address: locationState.address || '',
      zipcode: locationState.zipcode || '',
      lat: locationState.lat || null,
      long: locationState.long || null,
      uuid: locationState.uuid || null,
      isApiLoading: false,
      map: null,
      markers: [],
      selectedLocation: null,
      surcharge: 0,
      surcharge_type: '',
      fee: 0,
      isModalOpen: false
    };
    this.calculateFee = this.calculateFee.bind(this);
  }

  componentDidMount() {
    if (!this.state.businesses.length || !this.state.lat || !this.state.long) {
      this.props.history.push('/dashboard/amount-available');
      return;
    }
    this.loadGoogleMapsApi();
  }

  closeOverlay = () => this.setState({ selectedLocation: null, isModalOpen: false });

  fetchExistingLocations = () => {
    try {
      const { businesses, map } = this.state;
      const markers = [];
      businesses.forEach(business => {
        const position = { lat: business.latitude, lng: business.longitude }
        const marker = new window.google.maps.Marker({
          position: position,
          map,
          title: business.business_name,
        });

        marker.addListener('click', () => {
          this.handleClick(business);
        });

        markers.push(marker);
      });
      this.setState({ markers });
    } catch (e) {
      const { t } = this.props;
      return error(t('location:errors.generic_title'), e.message);
    }
  }

  findDirections = () => {
    const location = this.state.selectedLocation
    if (location) {
      const { address } = location
      const dUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`
      window.open(dUrl, '_blank')
    }
  }

  handleClick = (location) => {
    this.setState(
      {
        selectedLocation: location,
        isModalOpen: true,
        surcharge: location.surcharge || 0,
        surcharge_type: location.surcharge_type || 'Default'
      },
      () => {
        this.calculateFee();
      }
    );
  }

  selectAmount = () => {
    const { selectedLocation, requested_amount, uuid, fee } = this.state;
    const { t } = this.props;

    this.setState({ isApiLoading: true }, () => {
      const finalBody = {
        ...defaultFormValues(),
        amount: requested_amount,
        currency: 1,
        agent_registration_id: selectedLocation.registration_id,
        access_token: this.props.recoilStates.accessTokenState.state
      };

      fetch(`${api.main}/send_cash_request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: queryString.stringify(finalBody)
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(res => {
          this.setState({ isApiLoading: false }, () => {
            if (res.status !== 104) {
              Modal.error({
                title: t('location:errors.generic_title'),
                content: res.message || t('location:errors.send_cash_failed')
              })
            } else {
              this.props.recoilStates.merchantAddressState.setState(selectedLocation.address)
              this.props.recoilStates.merchantNameState.setState(selectedLocation.business_name)
              this.props.recoilStates.amountState.setState(requested_amount)
              this.props.saveCashRequestDto(res.data)
                .then(_ => {
                  this.props.history.push({
                    pathname: '/dashboard/pickup',
                    state: {
                      zipcode: selectedLocation.zipcode,
                      fee: fee,
                      uuid: uuid
                    }
                  })
                })
            }
          });
        })
        .catch(err => {
          console.error('Cash request error:', err);
          message.error(t('location:errors.internal_server'));
          this.setState({ isApiLoading: false });
        })
    });
  };

  calculateFee() {
    const selectedLocation = this.state.selectedLocation;

    if (!selectedLocation) {
      this.setState({ fee: 0 });
      return;
    }

    const surcharge = selectedLocation.surcharge || 0;
    this.setState({ fee: surcharge });
  }

  loadGoogleMapsApi = async () => {
    const { t } = this.props;
    const loadScript = () => {
      return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      })
    }

    try {
      await loadScript();
      await this.initMap();
      await this.fetchExistingLocations();
    } catch (e) {
      console.error("Failed to load Google Maps API: ", e.message);
      message.error(t('location:errors.maps_load_failed'));
    }
  }

  initMap = async () => {
    const { t } = this.props;
    try {
      const position = { lat: this.state.lat, lng: this.state.long };

      let map = new window.google.maps.Map(document.getElementById("map"), {
        center: position,
        zoom: 10,
      });

      let circle = new window.google.maps.Circle({
        strokeColor: '#ADD8E6',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#BAC9FF',
        fillOpacity: 0.35,
        map: map,
        center: position,
        radius: 24140.2, // ~15 miles
      });

      new window.google.maps.Marker({
        position: position,
        map: map,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 6,
          fillColor: '#5072ef',
          fillOpacity: 1,
          strokeWeight: 0,
        },
        title: t('location:center_of_radius'),
      });

      map.fitBounds(circle.getBounds());

      this.setState({ map });
    } catch (e) {
      console.error("Error initializing map ", e.message);
    }
  };

  render() {
    const { selectedLocation, requested_amount, address, isModalOpen } = this.state;
    const { t } = this.props;

    return (
      <div className="location-selector">
        <Header />
        <div className="ls-container ls-mt-4">
          <div className="spare-dvs">
            <div className="ls-w-100 ls-float-left">
              <div className="pickup-container">
                {/* Left / Bottom */}
                <div className="flex-item ls-card">
                  <div className="ls-header">
                    <button
                      onClick={() => this.props.history.push("/dashboard/")}
                      className="ls-back-btn"
                      aria-label="Back"
                      title="Back"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 19l-7-7 7-7" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <line x1="8" y1="12" x2="20" y2="12" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h2 className="ls-header-title">{t('location:title')}</h2>
                    <HelpHeader />
                  </div>

                  <h4>{t('location:click_map')}</h4>
                  <p className="ls-radius-note">
                    {t('location:radius_note')}
                  </p>

                  <div className="info-container">
                    <div className="info-header">
                      <h4 className="ls-info-subtitle">{t('location:pickup_amount')}</h4>
                      <h4>${requested_amount}</h4>
                    </div>
                    <div className="divider"></div>
                    <div className="info-content">
                      <div className="merchant-info">
                        <img src="../images/location.png" alt="" className="location-icon" />
                        <p>{t('location:showing_near')}</p>
                      </div>
                      <h4 className="address">{address}</h4>
                    </div>
                  </div>
                </div>

                {/* Right / Top */}
                <div className="flex-item map-container">
                  <div id="map"></div>

                  {selectedLocation && isModalOpen && (
                    <div className="ls-overlay" onClick={this.closeOverlay}>
                      <div className="location-info ls-location-info" onClick={(e) => e.stopPropagation()}>
                        <div className="ls-modal-closebar">
                          <button className="ls-close-btn" onClick={this.closeOverlay}>
                            <p className="ls-close-text">X</p>
                          </button>
                        </div>

                        <div><h3 className="ls-selected-label">{t('location:selected_merchant')}</h3></div>
                        <div><h1 className="ls-display-4">{selectedLocation.business_name}</h1></div>
                        <div><h3 className="ls-fee">
                          {t('location:transaction_fee')}: ${this.state.fee.toFixed(2)}
                        </h3></div>
                        <div><p className="ls-address">{selectedLocation.address}</p></div>

                        {selectedLocation.banner_url && (
                          <div>
                            <p className="ls-sponsor-label">{t('location:sponsored_by')}</p>
                            <img
                              className="ls-sponsor-image"
                              src={selectedLocation.banner_url}
                              alt={selectedLocation.sponsor_name}
                            />
                          </div>
                        )}

                        <div className="ls-actions">
                          <button className="action-button btn" onClick={this.findDirections}>
                            {t('location:directions')}
                          </button>
                          <button className="action-button btn" onClick={this.selectAmount}>
                            {t('location:select')}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      tokenAction,
      saveCashRequestDto,
    },
    dispatch
  );

const mapStateToProps = (state) => {
  return {
    token: state.token,
    profile: state.profile,
  };
};

export default withTranslation('location')(
  connect(mapStateToProps, mapDispatchToProps)(
    withRouter(
      withRecoil(LocationSelector, [accessTokenState, merchantAddressState, merchantNameState, amountState])
    )
  )
);
